/**
 * 애플리케이션 설정 관련 상수 정의
 */

export const PREFIX = "baoview";

export const ENC_KEY = null;

export const ENC_TYPE = null;

export const TIMEOUT = 150;

export const ACCOUNT_ID_TYPE = {ID: "ID", EMAIL: "EMAIL"};